import Loadable from '../../../loadable';

export default Loadable(() => import('./index'));
